// frontend/src/pages/legal/LegalLayout.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/about',   label: 'About' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms',   label: 'Terms' },
  { to: '/cookies', label: 'Cookies' },
  { to: '/gdpr',    label: 'GDPR' },
];

const backBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '6px 12px',
  background: 'var(--bg-elevated)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  color: 'var(--text-secondary)',
  fontSize: 12,
  fontWeight: 600,
  textDecoration: 'none',
  transition: 'color 0.15s, border-color 0.15s',
  marginBottom: 24,
};

const LegalLayout = ({ title, lastUpdated, children }) => {
  const location = useLocation();

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        background: 'var(--bg)',
      }}
    >
      <div style={{ padding: '32px 20px 48px' }}>
        <div
          style={{
            maxWidth: 768,
            margin: '0 auto',
            background: 'var(--bg-surface)',
            border: '1px solid var(--border)',
            borderRadius: 12,
            boxShadow: 'var(--shadow-sm)',
            padding: '28px 36px 32px',
          }}
        >
          {/* Back button */}
          <Link
            to="/"
            style={backBtnStyle}
            onMouseEnter={e => {
              e.currentTarget.style.color = 'var(--text-primary)';
              e.currentTarget.style.borderColor = 'var(--text-muted)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.color = 'var(--text-secondary)';
              e.currentTarget.style.borderColor = 'var(--border)';
            }}
          >
            <svg
              width="12" height="12" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" strokeWidth="2.5"
              strokeLinecap="round" strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to Home
          </Link>

          {/* Title + meta */}
          <h1
            style={{
              fontSize: 26,
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: 'var(--text-primary)',
              margin: '0 0 6px',
            }}
          >
            {title}
          </h1>
          {lastUpdated && (
            <p
              style={{
                fontSize: 11,
                fontWeight: 500,
                color: 'var(--text-muted)',
                letterSpacing: '0.03em',
                margin: '0 0 28px',
              }}
            >
              Effective {lastUpdated} · DrivenBy Limited
            </p>
          )}

          {/* Body */}
          <div
            className="legal-content"
            style={{ fontSize: 14, lineHeight: 1.7, color: 'var(--text-secondary)' }}
          >
            {children}
          </div>

          {/* Bottom mini-nav */}
          <div
            style={{
              marginTop: 36,
              paddingTop: 20,
              borderTop: '1px solid var(--border-subtle)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 10,
              fontSize: 12,
            }}
          >
            {NAV_LINKS.map((link, i) => {
              const isActive = location.pathname === link.to;
              return (
                <React.Fragment key={link.to}>
                  {i > 0 && <span style={{ color: 'var(--border)' }}>·</span>}
                  <Link
                    to={link.to}
                    style={{
                      color: isActive ? 'var(--accent)' : 'var(--text-secondary)',
                      fontWeight: isActive ? 600 : 500,
                      textDecoration: 'none',
                      transition: 'color 0.15s',
                    }}
                    onMouseEnter={e => {
                      if (!isActive) e.currentTarget.style.color = 'var(--text-primary)';
                    }}
                    onMouseLeave={e => {
                      if (!isActive) e.currentTarget.style.color = 'var(--text-secondary)';
                    }}
                  >
                    {link.label}
                  </Link>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalLayout;